import { Link } from 'react-router-dom';
import SubtleAnimalLogo from './SubtleAnimalLogo';
import './PageHeader.css';

export default function PageHeader({
  secondaryLabel = 'Private & Group Bookings',
  secondaryHref = '/#workshops',
}) {
  return (
    <header className="page-header">
      <Link to="/" className="page-header-brand" aria-label="Subtle Animal home">
        <SubtleAnimalLogo className="page-header-logo" />
      </Link>
      <div className="page-header-actions">
        <a href="/#events" className="btn btn-ghost page-header-btn">Book Upcoming Workshops</a>
        {secondaryHref.startsWith('/') ? (
          <Link to={secondaryHref} className="btn page-header-btn page-header-btn--primary">{secondaryLabel}</Link>
        ) : (
          <a href={secondaryHref} className="btn page-header-btn page-header-btn--primary">{secondaryLabel}</a>
        )}
      </div>
    </header>
  );
}
